module.exports = __webpack_public_path__ + "img/thumbs-up-regular-full.4a620e45.svg";